const LandingPageSkeleton = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white dark:from-gray-900 dark:to-gray-800">
      <div className="container mx-auto px-4 py-16">
        <div className="text-center mb-16">
          {/* Logo skeleton */}
          <div className="flex justify-center mb-6">
            <div className="h-24 w-24 rounded-full bg-gray-200 dark:bg-gray-700 animate-pulse" />
          </div>
          
          {/* Title skeletons */}
          <div className="h-8 w-2/3 mx-auto bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse mb-4" />
          <div className="h-6 w-1/2 mx-auto bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse mb-8" />
          <div className="h-12 w-3/4 mx-auto bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse mb-6" />
          <div className="h-6 w-2/3 mx-auto bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse mb-8" />

          {/* Button skeletons */}
          <div className="flex justify-center gap-4">
            <div className="h-12 w-32 bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse" />
            <div className="h-12 w-32 bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse" />
          </div>
        </div>

        {/* Feature cards skeleton */}
        <div className="grid md:grid-cols-3 gap-8 mt-16">
          {[1, 2, 3].map((item) => (
            <div key={item} className="p-6 bg-white dark:bg-gray-800 rounded-xl shadow-md">
              <div className="h-6 w-1/3 bg-gray-200 dark:bg-gray-700 rounded animate-pulse mb-4" />
              <div className="h-20 w-full bg-gray-200 dark:bg-gray-700 rounded animate-pulse" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LandingPageSkeleton;
